/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {ApiResponse} from '../../data/types/interface/api';
import {DevisItemResponse} from '../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {
  IModificationContrat,
  IPostDevis,
  ISaveDevis,
  souscriptionAssureBodyDTO,
} from '../applicatif/voyages';
import api, {postFormData} from '../technique/api';

dayjs.extend(customParseFormat);

const formatDate = (date: Date | string) =>
  typeof date == 'object'
    ? dayjs(date).startOf('day').format('YYYY-MM-DD')
    : date;

interface SouscriptionDataDTO {
  agence: string;
  montant: string;
  assure: Array<souscriptionAssureBodyDTO>;
  quoteCode: string;
}

export const VoyageBDL = () => ({
  // POST Devis
  postDevis: async (
    data: IPostDevis & {enfant: number; adult: number; senior: number},
  ) =>
    await api.post('voyage/quote', {
      motif: data?.motif || '',
      dateDebut: formatDate(data.dateDebut),
      dateFin: formatDate(data.dateFin),
      categories: data.idCategory,
      destination: data.idDestination,
      dateNaissance: data.dateNaissance,
      enfant: `${data.enfant}`,
      adult: `${data.adult}`,
      senior: `${data.senior}`,
    }),

  // save POST Devis
  saveDevis: async (data: ISaveDevis) =>
    await api.post('voyage/quote/save', {
      motif: data?.motif || '',
      dateDebut: formatDate(data.dateDebut),
      dateFin: formatDate(data.dateFin),
      categories: data.idCategory,
      destination: data.idDestination,
      dateNaissance: data.dateNaissance,
      listNaissance: data.listNaissance,
      enfant: data.enfant,
      adult: data.adult,
      senior: data.senior,
    }),

  // DELETE Devis
  removeDevis: async (id: string) =>
    await api.remove(`voyage/deleteSimulation?simulationId=${id}`),

  // POST Souscription
  souscrireContrat: async (data: SouscriptionDataDTO) => {
    const dataFormated = {
      quote_code: data.quoteCode,
      beneficiaries: data.assure.map((element: any) => ({
        title: 'M',
        first_name: element.first_name,
        last_name: element.last_name,
        birth_date: element.birth_date,
        passport_number: element.passport_number,
        email: element.email,
        phone_number: element.phone_number,
        residence_country: 'Madagascar',
        nationality: 'Malagasy',
        cin: '',
        profession: '',
        address: '',
        status: '',
        passportFile: element.passport_file,
      })),
      agence: data.agence,
      montant: parseInt(data.montant, 10),
    };
    console.log(data, 'formated to', dataFormated);

    const res: any = await api.post('voyage/subscription', dataFormated);
    return res;
  },

  // GET list devis
  listDevis: async (): Promise<ApiResponse<DevisItemResponse[]>> =>
    await api.get('voyage/quote'),

  // GET list destination
  listDestinations: async (category: string) => {
    return await api.get(`voyage/destinations?categorie=${category}`);
  },

  // GET list destination
  listCategories: async () => await api.get('voyage/categories'),

  // GET detail contrat
  detailContrat: async (numPolice: string) =>
    await api.get(`voyage/contrat?policyNumber=${numPolice}`),

  // POST Resiliaiton contrat
  resiliationContrat: async (data: {policyId: string; message: string}) =>
    await api.post('voyage/ristourne/resiliation', {
      policyId: data.policyId,
      cancellation_reason: data.message,
    }),

  // POST Modification contrat
  modificationContrat: async (data: IModificationContrat) => {
    const dataToSendBDL = {
      start_date: dayjs(data.dateDebut).startOf('day').format('YYYY-MM-DD'),
      end_date: dayjs(data.dateFin).startOf('day').format('YYYY-MM-DD'),
      beneficiaries: [
        ...data.assure.map(element => ({
          id: element.axaId,
          email: element.email,
          title: 'M',
          last_name: element.nom,
          first_name: element.prenom,
          phone_number: element.phoneNumber,
          passport_number: element.passeportNumber,
          passportFile: element.passeportFile,
        })),
      ],
    };
    const res: any = await api.put(
      `voyage/contrat/${data.policyId}`,
      dataToSendBDL,
      true,
    );
    return res;
  },

  getPolicyNumberByQuoteCode: async (
    quoteCode: string,
    url: string = 'voyage/contrat/create',
  ) => await api.post(url, {simulationId: quoteCode}),

  getStatusPayment: async (url: string = 'common/api-control') =>
    await api.get(url),

  uploadPassportPhoto: async (file: File) => {
    const formData = new FormData();
    formData.append('folderPath', 'passport');
    formData.append('file', file);
    return postFormData(`voyage/files/upload`, formData);
  },
});
